import React from 'react';
import classnames from 'classnames';
import bemBlock from '@gik/core/utils/bemBlock';
import TestimonialsCarouselCard from './TestimonialsCarouselCard';
import { UIBoxVariant } from '../../types';
import BoxCarousel, { IBoxCarouselProps } from '../BoxCarousel';
import { ITestimonial } from '@gik/core/models/gik/ITestimonial';

export interface ITestimonialsCarouselProps extends IBoxCarouselProps {
  items?: ITestimonial[];
  variant?: UIBoxVariant;
}

export default function TestimonialsCarousel({
  items,
  className,
  fadeSides = true,
  contained = true,
  variant = 'primary',
  ...otherProps
}: ITestimonialsCarouselProps): React.ReactElement {
  const bem = bemBlock('testimonials-carousel');
  const blockClasses = classnames([bem(), className || '']);

  return (
    <BoxCarousel variant={variant} fadeSides={fadeSides} contained={contained} className={blockClasses} {...otherProps}>
      {items?.map((item: ITestimonial, index) => (
        <TestimonialsCarouselCard key={index} {...item} />
      ))}
    </BoxCarousel>
  );
}
